import { render, staticRenderFns } from "./DonationDetailsModal.vue?vue&type=template&id=5631e9f3&"
import script from "./DonationDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DonationDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DonationDetailsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5631e9f3')) {
      api.createRecord('5631e9f3', component.options)
    } else {
      api.reload('5631e9f3', component.options)
    }
    module.hot.accept("./DonationDetailsModal.vue?vue&type=template&id=5631e9f3&", function () {
      api.rerender('5631e9f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Donations/DonationDetailsModal.vue"
export default component.exports